import { useI18n } from '@radical/locale'

const { t } = useI18n()

// 实例是其他管理页面的依赖项，单独管理
const home: RouteRecordItem = {
  path: '/home',
  name: 'Home',
  component: () => import('@/pages/home/index.vue'),
  meta: {
    title: t('routes.home.实例管理'),
    hideMenu: true,
    hideTab: true,
  },
}

export default home
